/**
 * TTSStatusBanner - P0 FINAL HOLE: No polling, no recovery controls
 * 
 * This component is INTENTIONALLY NEUTERED per P0 directive:
 * - NO polling of any TTS status endpoints
 * - NO recovery buttons
 * - NO progress display
 * 
 * The UI shows "Preparing" until backend declares DONE or FAIL.
 * Status comes from page refresh only, not real-time polling.
 */
import React from 'react';

const TTSStatusBanner = () => {
  // P0 FINAL HOLE: This component is intentionally disabled
  // TTS status comes from page refresh, not polling
  // No UI recovery controls allowed
  return null;
};

export default TTSStatusBanner;
